// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../icons/logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu-icon {
    position: absolute;
    top: 20px;
    right: 20px;
    background: none;
    border: none;
    font-size: 24px;
    color:rgb(0, 0, 156);
    cursor: pointer;
    z-index: 1000;
  }
  
  .menu-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
  }
  
  .menu-content {
    border-radius: 10px;
    padding: 20px;
    text-align: center;
    width: 99%;
    height: 99%;
    background:linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)), url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-color: rgb(255, 255, 255);
    background-size:contain; /* Para que la imagen cubra toda el área */
    background-position: center; /* Centra la imagen */
    background-repeat: no-repeat; /* Evita que la imagen se repita */

    display: flex;
    flex-direction: column;
    align-items: center; /* Centra horizontalmente el contenido */
    justify-content: center; /* Opcional: centra verticalmente si hay más espacio */
  }
  
  .close-icon {
    position: fixed;
    top: 30px;
    left: 50%;
    transform: translateX(-50%);
    background: red;
    border-radius: 30px;
    border: none;
    font-size: 30px;
    cursor: pointer;
  }
  
  .menu-content ul {
    list-style: none;
    padding: 0;
  }
  
  .menu-content ul li {
    margin: 20px 0;
  }
  
  .menu-content ul li a,
  .menu-content ul li button {
    text-decoration: none;
    font-size: 18px;
    color: black;
    font-weight: bold;
    background: none;
    border: none;
    cursor: pointer;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Menu.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,uHAAwG;IACxG,oCAAoC;IACpC,uBAAuB,EAAE,0CAA0C;IACnE,2BAA2B,EAAE,qBAAqB;IAClD,4BAA4B,EAAE,kCAAkC;;IAEhE,aAAa;IACb,sBAAsB;IACtB,mBAAmB,EAAE,wCAAwC;IAC7D,uBAAuB,EAAE,sDAAsD;EACjF;;EAEA;IACE,eAAe;IACf,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;;IAEE,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,eAAe;EACjB","sourcesContent":[".menu-icon {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    background: none;\n    border: none;\n    font-size: 24px;\n    color:rgb(0, 0, 156);\n    cursor: pointer;\n    z-index: 1000;\n  }\n  \n  .menu-background {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.8);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 10000;\n  }\n  \n  .menu-content {\n    border-radius: 10px;\n    padding: 20px;\n    text-align: center;\n    width: 99%;\n    height: 99%;\n    background:linear-gradient(rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)), url('../icons/logo.png');\n    background-color: rgb(255, 255, 255);\n    background-size:contain; /* Para que la imagen cubra toda el área */\n    background-position: center; /* Centra la imagen */\n    background-repeat: no-repeat; /* Evita que la imagen se repita */\n\n    display: flex;\n    flex-direction: column;\n    align-items: center; /* Centra horizontalmente el contenido */\n    justify-content: center; /* Opcional: centra verticalmente si hay más espacio */\n  }\n  \n  .close-icon {\n    position: fixed;\n    top: 30px;\n    left: 50%;\n    transform: translateX(-50%);\n    background: red;\n    border-radius: 30px;\n    border: none;\n    font-size: 30px;\n    cursor: pointer;\n  }\n  \n  .menu-content ul {\n    list-style: none;\n    padding: 0;\n  }\n  \n  .menu-content ul li {\n    margin: 20px 0;\n  }\n  \n  .menu-content ul li a,\n  .menu-content ul li button {\n    text-decoration: none;\n    font-size: 18px;\n    color: black;\n    font-weight: bold;\n    background: none;\n    border: none;\n    cursor: pointer;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
